import React, { useContext, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react-lite';
import CalciteThemeProvider from 'calcite-react/CalciteThemeProvider';
import ActionBar, { Action } from 'calcite-react/ActionBar';
import LayersIcon from 'calcite-ui-icons-react/LayersIcon';
import LegendIcon from 'calcite-ui-icons-react/LegendIcon';
import InformationIcon from 'calcite-ui-icons-react/InformationIcon';
import QuestionIcon from 'calcite-ui-icons-react/QuestionIcon';
import BookmarkIcon from 'calcite-ui-icons-react/BookmarkIcon';
import MeasureIcon from 'calcite-ui-icons-react/MeasureIcon';
import FilterIcon from 'calcite-ui-icons-react/FilterIcon';
import TopNav, {
    TopNavBrand,
    TopNavTitle,
    TopNavList,
    TopNavLink,
    TopNavActionsList
} from 'calcite-react/TopNav';
import Loader from 'calcite-react/Loader';
import { CookiesProvider } from 'react-cookie';

import EsriLogo from './assets/Paso_Robles_seal.jpg';
import { LayerList } from './components/LayerList';
import { Legend } from './components/Legend';
import { Bookmarks } from './components/Bookmarks';
import { Search } from './components/Search';
import { Measure } from './components/Measure';
import { Filter } from './components/Filter';
import { Information } from './components/Information';
import './styles.css'
import MapStore from './MapStore';


export const App = observer(() => {
    const store = useContext(MapStore);
    const mapRef = useRef(null);

    const WidgetAside = observer(() => {

        if (store.actionbar.layers) {
            return store.view === null ? <Loader text="Loading LayerList..."/>
            : <LayerList setLayerList={store.setLayerList} view={store.view} />;
        } else if (store.actionbar.legend) {
            return store.view === null ? <Loader text="Loading Legend..."/>
            : <Legend view={store.view} />
        } else if (store.actionbar.bookmarks) {
            return store.view === null ? <Loader text="Loading Bookmarks..."/>
            : <Bookmarks view={store.view} />
        } else if (store.actionbar.measure) {
            return store.view === null ? <Loader text="Loading Measure..."/>
            : <Measure view={store.view} setSelectMeasure={store.setSelectMeasure} />
        } else if (store.actionbar.filter) {
            return store.view === null ? <Loader text="Loading Filter..."/>
            : <Filter view={store.view} />
        } else if (store.actionbar.information) {
            return store.view === null ? <Loader text="Loading Information..."/>
            : <Information view={store.view} />
        } else {
            return null;
        }
    });

    useEffect(() => {
        const runEffect = async () => {
            store.loadMap(mapRef.current);
        }
        runEffect();
    }, []);

    return (
        <CalciteThemeProvider>
            <CookiesProvider>
            <div id='container'>
                <React.Fragment><div className='header'>
                    <TopNav style={{ width: "100%", height: '50px' }}>
                        <TopNavBrand href="https://www.prcity.com/367/Beechwood-Specific-Plan---Conceptual-Nei" src={EsriLogo} />
                        <TopNavTitle>Beechwood Specific Plan - Transportation Improvements</TopNavTitle>
                        <TopNavList>
                            <div />
                        </TopNavList>
                        {store.view === null ? <Loader sizeRatio={0.25} text="Loading search..."/>
                        : <Search view={store.view} popup={store.popup} />}
                        <TopNavActionsList>
                            {/* <Button clear onClick={showToaster}>Sign Up</Button> */}
                        </TopNavActionsList>
                    </TopNav>
                </div>
                <div id='main'>
                    <nav id='action-bar'>
                        <ActionBar collapsed={store.actionbar.collapse} onToggleCollapse={store.setActionBarCollapse}>
                            <Action id={'layers'} key={1} icon={<LayersIcon filled />} active={store.actionbar.layers} onClick={store.setSelectButton} >Layer List</Action>
                            <Action id={'legend'} key={2} icon={<LegendIcon filled />} active={store.actionbar.legend} onClick={store.setSelectButton} >Legend</Action>
                            <Action id={'bookmarks'} key={3} icon={<BookmarkIcon filled />} active={store.actionbar.bookmarks} onClick={store.setSelectButton} >Bookmarks</Action>
                            <Action id={'measure'} key={4} icon={<MeasureIcon filled />} active={store.actionbar.measure} onClick={store.setSelectButton} >Measure</Action>
                            <Action id={'information'} key={5} icon={<InformationIcon filled />} active={store.actionbar.information} onClick={store.setSelectButton} >Information</Action>
                        </ActionBar>
                    </nav>
                    <aside className={store.actionbar.layers || store.actionbar.legend || store.actionbar.bookmarks || store.actionbar.measure || store.actionbar.information || store.actionbar.filter ? 'open' : 'close'}>
                        <WidgetAside />
                    </aside>
                    <div id='viewDiv' className='webmap' ref={mapRef} />
                </div></React.Fragment>
            </div>
            </CookiesProvider>
        </CalciteThemeProvider>
    )
});

const rootElement = document.getElementById('root')
ReactDOM.render(<App />, rootElement)